import React from 'react';
import { observer } from 'mobx-react';
import styled from '@emotion/styled';
import Text from 'components/text';
import MemrevLogo from 'components/memrev_logo';
import { AppUI } from '@seedlang/state';
import PatreonButton from 'components/user/patreon_button';
import { isPresent } from '@seedlang/utils/src';
import Link from 'components/link';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px;
  @media only screen and (max-width : 649px) {
    padding: 20px 0;
  }
  color: #494747;
  @media only screen and (max-width : 649px) {
    background: #FFF;
  }
`;

const Content = styled.div`
  border-radius: 12px;
  margin: 38px 0 20px 0;
  max-width: 800px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 40px 10px 40px;
  @media only screen and (max-width : 649px) {
    padding: 20px 5px;
    border-radius: 0px;
    margin: 10px 0;
  }
  background: #FFF;
`;

const InnerText = styled.div`
  padding: 25px 100px;
  @media only screen and (max-width : 649px) {
    padding: 25px;
  }
  display: flex;
  flex-direction: column;
  gap: 2px;
  ol > li::marker {
    font-weight: bold;
  }
  li {
    margin-bottom: 5px;
  }
  p {
    margin-block-start: 10px;
    margin-block-end: 10px;
  }
`;

const Footer = styled.div`
  text-align: center;
  max-width: 600px;
  @media only screen and (max-width : 649px) {
    padding: 0 10px;
  }
`;

const ContactLink = styled.div`
  margin-top: 5px;
  font-size: 16px;
`;

@observer
class PatreonConnect extends React.Component {

  render() {
    return (
      <Wrapper>
        <a href='.'>
          <MemrevLogo />
        </a>
        <Content>
          <Text heading={1} center style={{maxWidth: '80%'}}>Already a Patreon Member?</Text>
          <InnerText>
            <p>If you have an <strong>active, paid membership with {AppUI.site.teamName} on Patreon</strong>, you can connect your Patreon account to our new membership platform. This will allow you to use all of your benefits in one place.</p>
            <p>What to do:</p>
            <ol>
              <li><strong>Create</strong> an account on our site</li>
              <li><strong>Connect</strong> your Patreon account</li>
              <li><strong>Migrate</strong> your payment method (optional)</li>
            </ol>
            <p style={{marginTop: '20px'}}>This connection is only for paid members on Patreon. If your Patreon membership is free or expired,
              {' '}<Link to='onboarding.register' className='underline'>register for a free account</Link> instead.
            </p>

            <PatreonButton
              margin='20px 0'
              width='330px'
              height='56px'
              borderRadius='36px'
              fontSize='18px'
              scaleOnHover='1.1'
            />
            <Text color='#656565' textAlign='center' fontSize={12} lineHeight={18}>
              By connecting your Patreon account, you are creating an account with {AppUI.site.teamName} under Easy Languages GmbH and Seedlang, Inc. You agree to Easy Languages GmbH <a target='blank' href={AppUI.site.termsOfServiceUrl}>Terms of Use</a> & <a target='blank' href={AppUI.site.privacyUrl}>Privacy Policy</a> and Seedlang, Inc’s <a target='blank' href='https://seedlang.com/terms'>Terms of Use</a> & <a target='blank' href='https://seedlang.com/privacy'>Privacy Policy</a>.
            </Text>

          </InnerText>
        </Content>
        <Footer>
          <ContactLink><a target='_blank' rel='noopener noreferrer' href={`mailto:${AppUI.site.supportEmailAddress}`} className='underline'>If you have any questions, please contact us.</a></ContactLink>
          {
            isPresent(AppUI.site.paymentMigrationConfig?.infoUrl) &&
              <ContactLink><a target='_blank' rel='noopener noreferrer' href={AppUI.site.paymentMigrationConfig.infoUrl} className='underline'>Learn More About Our Migration Process</a></ContactLink>
          }
        </Footer>
      </Wrapper>
    );
  }
}

export default PatreonConnect;
